/*
 * Base.js
 * Copyright 2013-2016 Agentur Frontal AG
 * http://frontal.ch
 */

/*global $*/


$(document).ready(function () {

	'use strict';

	// Mobile Table
	$('table.table-mobile, table.table-mobile-striped').each(function () {
		var labels = [];

		$(this).find('th').each(function (headIndex) {
			labels[headIndex] = $(this).text();
		});

		$(this).find('tr').each(function () {
			$(this).children('td').each(function (cellIndex) {
				$(this).attr('data-content', labels[cellIndex]);
			});
		});
	});


	// Triggers the 'collapsed' class in the accordeon
	// Doesn't get change as should due to T3 adding the whole path in front of #-anchors
	$('.accordeon .panel-heading a').click(function () {
		$(this).toggleClass('collapsed');
	});


});
